<template>
    <AppLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Edit job
            </h2>
        </template>
        <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <div class="ml-2 mb-2">
                <inertia-link href="/" class="text-sm font-medium hover:underline text-gray-500">
                    Go back to index
                </inertia-link>
            </div>
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <JobEditForm :job="job"></JobEditForm>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import JobEditForm from "@/Jobroll/JobEditForm";
    import AppLayout from "@/Layouts/AppLayout";

    export default {
        name: 'EditJob',
        metaInfo: { title: 'Dashboard' },
        components: {
            JobEditForm,
            AppLayout
        },
        props: {
            message: String,
            job: Object
        }
    }
</script>
